<template>
  <div
    class="flex-y-center text-14 flex-1 table-wrapper absolute top-0 left-[220px] bottom-0 right-0"
  >
    <!-- <template v-if="item?.type === 'str'"> -->
    <div
      v-for="(detail, idx) in item?.rights_content"
      :key="idx"
      class="w-auto flex-1 card-item-bg text-font-90 text-center flex-y-center justify-center py-[20px] self-stretch"
    >
      <div v-if="typeof detail.value !== 'boolean'">
        <template v-for="(child, cdx) in detail.value?.split('\n')" :key="cdx">
          <span
            class="leading-[20px] mr-[8px]"
            v-html="checkChild(child)"
          ></span>
        </template>
      </div>
      <template v-else>
        <iconpark-icon
          v-if="detail.value"
          name="check-thin"
          size="14"
          class="text-primary text-success-6"
        ></iconpark-icon>
        <iconpark-icon
          v-else
          name="close"
          size="14"
          class="text-error-6"
        ></iconpark-icon>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { showContact } from '~/hooks/useModal/modals/contact'
import { type IRightsCompareItem } from '~/api/interface/rights'
import { PageKey } from '~/constants/page'

defineProps<{
  item?: IRightsCompareItem
  colorsMap: any
}>()

const checkChild = (val: string) => {
  return val.replaceAll('<a>', '<a class="contactUs" href="javascript:;">')
}

const route = useRoute()

nextTick(() => {
  if (import.meta.server) {
    return
  }

  const elContacts = document.querySelectorAll<HTMLAnchorElement>('a.contactUs')
  for (const alink of elContacts) {
    alink.addEventListener('click', () => {
      showContact('b-wechat-qr')
    })
  }
})
</script>

<style scoped>
.table-wrapper {
  border-collapse: collapse;
  border-left: 1px solid var(--back-5);
  &:hover {
    background-color: var(--back-2) !important;
  }
}

.card-item-bg {
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--back-5);
  &:last-child {
    border-right: unset;
  }
}

:deep(.contactUs) {
  color: var(--warning-8);
  text-decoration: none;
}

:deep(.contactUs:hover) {
  text-decoration: underline;
}
</style>
